import { useTranslation } from 'react-i18next';

export const ServiceVariableTooltip = () => {
  const { t: translate } = useTranslation();
  return (
    <>
      {String(translate('service_details_form_component.service_variable_tooltip_title'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_format'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_example'))}<br />
      {String(translate('service_details_form_component.service_variable_tooltip_azure'))}
    </>
  );
};
